import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit, NgZone } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { NgxRolesService } from 'ngx-permissions';
import { DataTablesResponse } from './../../../models/DataTablesResponse';
import { DataTableDirective } from 'angular-datatables';
import { HttpClient, HttpParams } from '@angular/common/http';
import * as moment from 'moment';
import { TripMessage } from '../../../models/tripMessage';
import { ActivatedRoute } from '@angular/router';
import { MalihuScrollbarService } from 'ngx-malihu-scrollbar';
declare const $: any;
import { Select2OptionData } from 'ng2-select2';
import { Router } from '@angular/router';
import { PNotifyService } from '../../../services/pnotify.service';

@Component({
  selector: 'app-trip-datatable',
  templateUrl: './trip-datatable.component.html',
  styleUrls: ['./trip-datatable.component.css']
})
export class TripDatatableComponent implements OnInit, OnDestroy, AfterViewInit {


  filter = {
    clientId: '',
    schoolId: '',
    busId: '',
    title: '',
    date: null,
  };
  staticFilter: any;
  tripMessages: TripMessage[];
  message: any;
  messageTitle: any;
  tripId: any;
  showFormMessage = true;
  public schoolsData: Array<Select2OptionData>;
  public busesData: Array<Select2OptionData>;

  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;

  // ----- Start Option Scrollbar -----------
  isScrollbar: true;
  // ----- End Option Scrollbar -----------

  selectedAll = false;
  selectedMulti = false;

  dtOptions: any = {};
  clients: any[];
  schools: any[];
  buses: any[];
  trips: any[];
  pnotify = undefined;
  isResponsible = false;
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private mScrollbarService: MalihuScrollbarService,
    private roleService: NgxRolesService,
    private router: Router,
    private zone: NgZone,
    pnotifyService: PNotifyService
  ) {
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      this.isResponsible = true;
      const client = this.authService.getUser().School.Client;
      this.filter.clientId = client.id;
    } else {
      const client = this.authService.getUser();
      this.filter.clientId = client.id;
    }
    this.initSchoolSelect();
    this.staticFilter = JSON.parse(JSON.stringify(this.filter));
    if (this.staticFilter.date) {
      this.staticFilter.date = moment(this.staticFilter.date).format('YYYY-MM-DD');
    } this.pnotify = pnotifyService.getPNotify();
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      this.isResponsible = true;
    }
  }


  ngOnInit(): void {
    this.dtOptions = {
      searching: false,
      pageLength: 5,
      serverSide: true,
      processing: true,
      lengthMenu: [[5, 10, 25, 50, 100], [5, 10, 25, 50, 100]],
      order: [[1, 'asc']],
      ordering: false,
      columnDefs: [
        { 'orderable': false, 'targets': 0 }
      ],
      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters.filter = this.staticFilter;
        this.http.post<DataTablesResponse>(
          '/api/trip',
          dataTablesParameters,
          {}
        ).subscribe((resp: any) => {
          this.trips = resp.data;
          const dta = [];
          this.trips.forEach(trip => {
            dta.push({
              id: trip.id,
              checkbox: `<label class="el-switch" style="font-size:80%">
                          <input  type="checkbox"
                                  name="checkboxs[]"
                                  value="${trip.id}"
                                  ${this.selectedAll ? 'checked' : ''}
                          >
                          <span class="el-switch-style"></span>
                        </label>`,
              busSchoolName: trip.Bus.School.name,
              title: trip.title,
              tripBusName: trip.Bus.name,
              departureDate: moment(trip.departureDate).format('DD/MM/YYYY  à HH:mm'),
              returnDate: moment(trip.returnDate).format('DD/MM/YYYY  à HH:mm'),
              activationCode: trip.activationCode,
              actions: `
                <a class="btn btnAction btnNavigate" data-url="/trip/view/${trip.id}">
                  <i class="fa fa-search fa-2x" aria-hidden="true"></i>Détail
                </a>
                <a class="btn btnAction btnNavigate" data-url="/trip/edit/${trip.id}">
                  <i class="fa fa-pencil fa-2x" aria-hidden="true"></i>Modifier
                </a>
                <button class="btn btnAction btnDelete" data-trip-id="${trip.id}">
                  <i class="fa fa-trash fa-2x" aria-hidden="true"></i>Supprimer
                </button>
                <button class="btn btnAction btnShowMsgTrip" data-trip-id="${trip.id}">
                <i class="fa fa-envelope fa-2x" aria-hidden="true"></i>Messages
              </button>
              `
            });
          });
          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: dta
          });
        });
      },
      fnCreatedRow: function (nRow, aData, iDataIndex) {
        $(nRow).attr('id', 'trip_' + aData.id);
      },
      columns: [
        { data: 'checkbox' },
        { data: 'busSchoolName' },
        { data: 'title' },
        { data: 'tripBusName' },
        { data: 'departureDate' },
        { data: 'returnDate' },
        { data: 'activationCode' },
        { data: 'actions' },
      ],
      dom: '<t> <"row" <"col-md-4"l><"col-md-8"p>>',
      language: {
        'sProcessing': 'Traitement en cours...',
        'sSearch': 'Rechercher&nbsp;:',
        'sLengthMenu': 'Afficher _MENU_ &eacute;l&eacute;ments',
        'sInfo': 'Affichage de l\'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_ &eacute;l&eacute;ments',
        'sInfoEmpty': 'Affichage de l\'&eacute;l&eacute;ment 0 &agrave; 0 sur 0 &eacute;l&eacute;ment',
        'sInfoFiltered': '(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)',
        'sInfoPostFix': '',
        'sLoadingRecords': 'Chargement en cours...',
        'sZeroRecords': 'Aucun &eacute;l&eacute;ment &agrave; afficher',
        'sEmptyTable': 'Aucune donn&eacute;e disponible dans le tableau',
        'oPaginate': {
          'sFirst': 'Premier',
          'sPrevious': 'Pr&eacute;c&eacute;dent',
          'sNext': 'Suivant',
          'sLast': 'Dernier'
        },
        'oAria': {
          'sSortAscending': ': activer pour trier la colonne par ordre croissant',
          'sSortDescending': ': activer pour trier la colonne par ordre d&eacute;croissant'
        }
      },
      // Use this attribute to enable the responsive extension
      responsive: true
    };
    $('table').on('click', '.btnDelete', (event) => {
      this.onDelete($(event.currentTarget).data('tripId'));
    });
    $('table').on('click', '.btnNavigate', (event) => {
      this.onNavigate($(event.currentTarget).data('url'));
    });
    $('table').on('click', '.btnShowMsgTrip', (event) => {
      this.showTripMsg($(event.currentTarget).data('tripId'));
    });
    $('table').on('change', '[name="checkboxs[]"]', (event) => this.onCheckChange());
    $('table').on('draw.dt', (event) => this.onCheckChange());

  }
  ngAfterViewInit() {
    this.mScrollbarService.initScrollbar('#trip_messages', {
      axis: 'y',
      theme: 'dark-3',
      scrollButtons: { enable: false },
    });
  }

  ngOnDestroy(): void {
    $.fn['dataTable'].ext.search.pop();
    $('table').off();
  }


  initSchoolSelect() {
    this.filter.schoolId = '';
    let params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId
      }
    });
    this.http.get(
      '/api/school/lookup',
      { params }
    ).subscribe((schools: any[]) => {
      this.schools = schools;
      const array1 = [{ id: '', text: 'Choisir une option' }];
      const array2 = this.schools.map((school, index) => {
        if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
          return {
            id: school.id,
            text: school.name,
            selected: (this.authService.getUser().School.id === school.id) ? true : false
          };
        } else {
          return { id: school.id, text: school.name };
        }
      });
      this.schoolsData = array1.concat(array2);
      // this.initBusSelect();
    });
  }

  schoolChanged(e: any) {
    this.filter.schoolId = e.value;
    this.initBusSelect();
  }

  initBusSelect() {
    this.filter.busId = '';
    let params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId,
        schoolId: this.filter.schoolId
      }
    });
    this.http.get(
      '/api/bus/lookup',
      { params }
    ).subscribe((buses: any[]) => {
      this.buses = buses;
      const array1 = [{ id: '', text: 'Choisir une option' }];
      const array2 = this.buses.map(function (bus, index) {
        return { id: bus.id, text: bus.name };
      });
      this.busesData = array1.concat(array2);
    });
  }
  busChanged(e: any) {
    this.filter.busId = e.value;
  }


  onSelectedAllChange() {
    $('[name="checkboxs[]"]').prop('checked', this.selectedAll);
    this.onCheckChange();
  }

  onCheckChange() {
    const length = $('[name="checkboxs[]"]:checked').length;
    if (length > 1) {
      this.selectedMulti = true;
    } else {
      this.selectedMulti = false;
    }
  }

  onNavigate(url) {
    this.zone.run(() => this.router.navigateByUrl(url));
  }

  onDelete(id) {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous supprimer cet element ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                this.delete(id);
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  onBulkDelete() {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous supprimer la selection ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                $('[name="checkboxs[]"]:checked').each((i, elt: any) => {
                  this.delete($(elt).val());
                });
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  delete(id) {
    this.http
      .delete('/api/trip/' + id)
      .subscribe(
        result => {
          document.getElementById('trip_' + id).remove();
        },
        error => {
          this.pnotify.error({
            title: 'Erreur',
            text: 'Une erreur est survenue !',
            stack: {
              firstpos1: 70, firstpos2: 10,
              modal: true,
              overlay_close: true
            },
            hide: false,
            modules: {
              Confirm: {
                confirm: true,
                buttons: [
                  {
                    text: 'Ok',
                    addClass: 'btn btn-chico',
                    click: notice => {
                      notice.close();
                    }
                  }
                ]
              }
            }
          });
        }
      );
  }

  onFilter(): void {
    this.staticFilter = JSON.parse(JSON.stringify(this.filter));
    if (this.staticFilter.date) {
      this.staticFilter.date = moment(this.staticFilter.date).format('YYYY-MM-DD');
    } this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.draw();
    });
  }


  showTripMsg(id) {
    this.trips.forEach(trip => {
      if (trip.id == id) {
        this.messageTitle = trip.title;
        this.tripId = trip.id;
        const now = new Date().getTime();
        const tripDate = new Date(trip.returnDate).getTime();
        this.showFormMessage = (tripDate < now) ? false : true;
      }
    });
    this.http.get(
      '/api/trip-msg/' + id)
      .subscribe((tripMessages: TripMessage[]) => {
        this.tripMessages = tripMessages;
        $('#myModal').modal('show');
        $('#myModal').on('shown.bs.modal', () => {
          this.goToBottom();
        });
      });
  }

  createMeessage() {
    console.log(this.message);

    if (this.message) {
      this.http.post(
        '/api/trip-msg/0',
        {
          tripMessage: {
            'tripId': this.tripId,
            'message': this.message,
            'datetime': moment().format(),
          }
        }
      ).subscribe(
        (tripMessage: TripMessage) => {
          this.tripMessages.push(tripMessage);
          this.message = '';
          // TODO: replace timeout by html update check
          setTimeout(() => { this.goToBottom(); }, 1000);
        },
        (error) => {
          this.pnotify.error({
            title: 'Erreur',
            text: 'Une erreur est survenue !',
            stack: {
              firstpos1: 70, firstpos2: 10,
              modal: true,
              overlay_close: true
            },
            hide: false,
            modules: {
              Confirm: {
                confirm: true,
                buttons: [
                  {
                    text: 'Ok',
                    addClass: 'btn btn-chico',
                    click: notice => {
                      notice.close();
                    }
                  }
                ]
              }
            }
          });
        },
      );
    }

  }

  goToBottom() {
    this.mScrollbarService.scrollTo('#trip_messages', 'bottom', {
      scrollInertia: 500
    });
  }

  onDeleteMsg(id) {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous supprimer cet element ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {

                this.http
                  .delete('/api/trip-msg/' + id)
                  .subscribe(
                    result => {
                      document.getElementById('tripMessage_' + id).remove();
                    },
                    error => {
                      this.pnotify.error({
                        title: 'Erreur',
                        text: 'Une erreur est survenue !',
                        stack: {
                          firstpos1: 70, firstpos2: 10,
                          modal: true,
                          overlay_close: true
                        },
                        hide: false,
                        modules: {
                          Confirm: {
                            confirm: true,
                            buttons: [
                              {
                                text: 'Ok',
                                addClass: 'btn btn-chico',
                                click: notice => {
                                  notice.close();
                                }
                              }
                            ]
                          }
                        }
                      });
                    }
                  );
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });

  }

}



// WEBPACK FOOTER //
// ./src/app/components/trip/trip-datatable/trip-datatable.component.ts